import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { CheckAvailabilityService } from './check-availability.service'
import { LoggerService } from 'app/logger/logger.service';
import { TDUModel } from '../shared/models/shared-models';

const ZIPCODE_REGEX: RegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;

@Component({
	selector: 'app-check-availability',
	templateUrl: './check-availability.component.html',
	styleUrls: ['./check-availability.component.css']
})
export class CheckAvailabilityComponent implements OnInit {

	serviceAddressFormControl = new FormControl('', [Validators.required]);
	apartmentFormControl = new FormControl('', [Validators.required]);

	public service_address_search: any = {};
	public service_address_array = [];
	public is_component_load: boolean;
	public showLoader: boolean;
	public is_error_address: boolean;
	public show_advanced_search: boolean;
	public is_error_address_yellow: boolean;
	public is_switchHold: boolean;
	public is_apt_exist: boolean;
	public multipleRecords: boolean = false;
	public duns: string;
	public selectedTdu: TDUModel;
	public tdus: Array<TDUModel> = [];
	public error_address: string;
	public error_address_yellow: string;
	public error_switchHold;
	public is_btn_enable: boolean;
	public which_event: string;
	public search_val: any;
	public apt_unit: string;
	public apartmentUnits: any = [];
	public apartmentList: any = [];
	public esiid: string;
	public apartment_obs: Observable<string[]>;
	public old_key: number;
	public zipcode: string;
	public showAddressItems: boolean = false;
	public showAptItems: boolean = false;
	public isCheckAvailabilityDisabled: boolean;
	public isSwitchHold: boolean = false;
	public acceptNewEnrollments = true;

	public acceptCenterpoint = true;
	public acceptOncor  = true;
	public acceptAEPNorth = true;
	public acceptAEPCentral = true;
	public acceptTnmp = true;

	public isTduEnrollmentBlocked = false;

	// These booleans allow us to replace the suggestions list with "Zip Code:xxxxx" when the user enters a zip code,
	// and to extract the zip code from the input field if the suggestion is selected
	public isZipCode: boolean = false;
	public isZipCodeSelected: boolean = false;

	constructor(private sharedService: SharedService, private logger: LoggerService,
		private service: CheckAvailabilityService, private router: Router,
		private localStorageService: LocalStorageService) {

		(window as any).dataLayer.push({ 'event': 'enroll - step 0' });

		this.sharedService.setHeaderTitleDynamicallyTrueFalse('home', false);

		let methodName = this.constructor.name + '.verifyToken';
		if (this.localStorageService.get('token') != null) {
			this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
				.then(res => {
					let logObj = {
						method: methodName,
						request: "token : [masked]",
						response: res
					};
					this.logger.logInfo(JSON.stringify(logObj));
					if (res.status === 'success' && res.isTerminated === false) {
						this.router.navigate(['./dashboard']);
					} else {
						this.localStorageService.remove('token');
						this.router.navigate(['./sign-in']);
					}
				}, (error) => {
					let logObj = {
						method: methodName,
						request: "token : [masked]",
						exception: error
					};
					this.logger.logError(JSON.stringify(logObj));
				}).catch((ex) => {
					let logObj = {
						method: methodName,
						request: "token : [masked]",
						exception: ex
					};
					this.logger.logError(JSON.stringify(logObj));
				});
		}
		else {
			this.is_component_load = true;

			this.sharedService.getElectricUtilityProviders().then(activeTdus => {
				this.tdus = activeTdus;
			});

			const context = this;
			setTimeout(function () {
				context.sharedService.setHeaderTitle('home');
				context.sharedService.InvokeHtmlElementEvent('service_address_id', 'focus');
			}, 50);
		}

		// Flag that enable / disable starting new enrollments
		this.sharedService.getConfigConst()
			.then(response => {
				if (response.status === 'success') {
					this.acceptNewEnrollments = response.results[0]['acceptNewEnrollments'];
					this.acceptCenterpoint = response.results[0]['acceptCenterpoint'];
					this.acceptOncor = response.results[0]['acceptOncor'];
					this.acceptAEPNorth = response.results[0]['acceptAEPNorth'];
					this.acceptAEPCentral = response.results[0]['acceptAEPCentral'];
					this.acceptTnmp = response.results[0]['acceptTnmp'];
				}
			});
	}

	showAdvancedSearch() {
		this.show_advanced_search = true;
		this.router.navigate(['./enroll/advancedsearch']);
	}

	ngOnInit() {
		this.serviceAddressFormControl.valueChanges.subscribe(searchKey => {
			this.is_error_address_yellow = false;
			this.is_error_address = false;
			this.is_switchHold = false;
			this.isCheckAvailabilityDisabled = true;
			var to_match;
			if (this.isZipCodeSelected) {
				var temp = searchKey.split(" ")
				to_match = temp[2];
			}
			else {
				to_match = searchKey;
			}

			this.isZipCodeSelected = false;

			if (searchKey != undefined && searchKey.trim() != '') {
				this.service.direct_search(searchKey)
					.then((res) => {

						this.service_address_array = [];

						//this was handling the elastic search response format

						/*if (res != undefined && res['suggest'] != undefined && res['suggest']['address-suggest'] != undefined && res['suggest']['address-suggest'].length > 0) {
						  // this.service_address_array = res['suggest']['address-suggest'][0]['options'] as any[];
						  this.service_address_array = this.get_service_array(res['suggest']['address-suggest'][0]['options']);
						}*/

						//azure search response format
						//each address has a search score, address_full, and FullAddressHashKey.

						if (res != undefined && res["value"] != undefined && res["value"].length > 0 && !to_match.match(ZIPCODE_REGEX)) {
							this.service_address_array = res["value"];
							this.isZipCode = false;
						}
						//adding else if and zipcode regex conditions
						else if (to_match.match(ZIPCODE_REGEX)) {
							this.service_address_array = [{
								address_full: "Zip Code: " + to_match
							}];
							this.isZipCode = true;
						}



						setTimeout(() => {
							this.showAddressItems = this.service_address_array.length > 0 && !this.isInAddressArray(searchKey);
						}, 100);

						if (this.service_address_array.length == 0) {
							this.is_error_address_yellow = true;
						}
					});
			} else {
				this.service_address_array = [];
				this.showAddressItems = false;
			}
		});
	}

	get_service_array(options: any[]) {
		let service_array = [];
		for (let i = 0; i < options.length; i++) {
			let opt = options[i];
			let ser_opt = {
				text: this.get_high_suggest(opt._source.suggest),
				_id: opt._source.objectid
			};
			service_array.push(ser_opt);
		}

		return service_array;
	}

	get_high_suggest(suggests: any[]) {
		let text = "";
		let maxLength = 0;
		for (let i = 0; i < suggests.length; i++) {
			let segg = suggests[i];
			if (segg.weight == 3) {
				return segg.input;
			}
		}
	}

	getAddressWithoutApt(address: string) {
		let address_part = address.split(",");
		let new_address = "";
		if (address_part != null && address_part.length > 5) {
			new_address = address_part[0] + "," + address_part[1] + "," + address_part[3] + "," + address_part[4] + "," + address_part[5]
		} else {
			new_address = address;
		}

		return new_address
	}

	addressEvent(event_value_pass: string) {
		this.is_error_address = false;
		this.is_error_address_yellow = false;
		this.is_apt_exist = false;
		this.apt_unit = '';
		this.esiid = '';
		this.apartmentList = [];
		let event_value: string;

		if (!this.isZipCodeSelected) {
			event_value = event_value_pass;
		}
		else {
			var temp = event_value_pass.split(" ");
			event_value = temp[2];
		}

		let address_hash = this.getHashKeyFromAddress(event_value);
		const context = this;

		if (address_hash != undefined && address_hash.trim() != '') {
			this.selectAddressHash(address_hash);
		}
		else if (event_value.match(ZIPCODE_REGEX)) {
			this.selectAddressHash(event_value);
		}
		else {
			if (event_value != undefined && event_value.trim() != '' && this.service_address_array.length == 0) {
				this.is_error_address_yellow = true;
				this.isCheckAvailabilityDisabled = true;
			}
		}
	}

	getHashKeyFromAddress(address) {
		for (let i = 0; i < this.service_address_array.length; i++) {
			let service_address = this.service_address_array[i];
			if (service_address["address_full"].trim() == address.trim()) {
				return service_address["FullAddressHashKey"];
			}
		}
		return "";
	}

	getTDUs() {
		this.isCheckAvailabilityDisabled = true;
		this.isZipCode = false;
		this.isZipCodeSelected = false;

		if (this.service_address_array.length === 0) {
			this.is_error_address = false;
			this.is_error_address_yellow = false;
			this.is_apt_exist = false;
		}
		else if (this.duns && this.esiid) {
			// TODO
			// We are just navigating - we should have already performed
			// basic input validation (have address, apt, esiid, etc)
			// we are not validating switch hold
			this.selectedTdu = this.tdus.find((x) => x.duns == this.duns);

			if (this.selectedTdu) {
				this.router.navigate(['./enroll/esiid/' + this.esiid + '/tdu/' + this.selectedTdu.tduCode]);
			}
			else {
				this.router.navigate(["./service-not-available"]);
			}
		}
		else if (this.multipleRecords) {
			this.router.navigate(['./enroll/zipcode/' + this.zipcode]);
		}
		else if (!this.multipleRecords && this.selectedTdu) {
			this.router.navigate(['./enroll/zipcode/' + this.zipcode + '/tdu/' + this.selectedTdu.tduCode]);
		}
		else {
			this.is_error_address = false;
			this.is_error_address_yellow = false;
			this.is_apt_exist = false;
		}
	}

	aptUnitEvent(event) {
		const enter_key = event.keyCode || event.which;

		if (event.type === 'keyup' && (enter_key === 13) || (this.old_key === 17 && enter_key === 86) ||
			(this.old_key === 86 && enter_key === 17)) {
			this.sharedService.InvokeHtmlElementEvent('apartment', 'blur');
		}
		this.old_key = enter_key;
	}

	selectAddress(service_address_search_text) {
		this.service_address_search["text"] = service_address_search_text;
		if (this.isZipCode) {
			this.isZipCodeSelected = true;
		}

		const context = this;
		setTimeout(() => {
			context.showAddressItems = false;
			let element = document.getElementById('service_address_id');
			if (element != undefined) {
				element.blur();
			}
		}, 200);

		this.addressEvent(service_address_search_text);
	}

	isInAddressArray(key: string) {
		let inArray: boolean = false;
		for (let i = 0; i < this.service_address_array.length; i++) {
			let arr_ele = this.service_address_array[i];
			//if (arr_ele.text.trim() == key.trim()) {
			if (arr_ele["address_full"].trim() == key.trim()) {
				inArray = true;
				break;
			}
		}
		return inArray;
	}

	isInAPtArray(key: string) {
		let inArray: boolean = false;
		for (let i = 0; i < this.apartmentList.length; i++) {
			let arr_ele = this.apartmentList[i];
			if (arr_ele.toString().trim() == key.trim()) {
				inArray = true;
				break;
			}
		}
		return inArray;
	}

	/** Search Electric Utility Provider (TDUs) for the address or zip-code */
	selectAddressHash(address_hash: string) {

		address_hash = address_hash ? address_hash.trim() : '';
		this.multipleRecords = false;

		// Invalid search
		if (address_hash == '') {
			this.isCheckAvailabilityDisabled = false;
			return;
		}

		this.showLoaderIcon(true);

		// Check if the person is searching by address or by zip-code
		if (address_hash.length > 5) {
			let requestObj = {
				'addressHash': address_hash
			};

			this.service.GetServiceAddressesByHash(requestObj)
				.then(response => {
					this.showLoaderIcon(false);
					this.multipleRecords = response.multipleRecord;

					// Address not found
					if (response.result.length < 0) {
						let dataLayerEvent = 'enroll - step 0: address issue';
						(window as any).dataLayer.push({ 'event': dataLayerEvent, 'error address_hash': address_hash });
						this.is_error_address_yellow = true;
						this.isCheckAvailabilityDisabled = true;
						this.error_address_yellow = this.sharedService.getErrorMessage('address_not_found');
						return;
					}

					// Show the Apartment Unit selector if needed
					this.showApartmentUnitSelector(response);
				});
		}
		// The person is searching by by zip-code
		else if (address_hash.match(ZIPCODE_REGEX)) {

			this.zipcode = address_hash;

			this.sharedService.getTDUsByZipCode(this.zipcode)
				.then((response) => {
					this.showLoaderIcon(false);
					if (response.status === 'success') {
						this.isCheckAvailabilityDisabled = false;
						this.multipleRecords = response.multipleRecord;
						if (!response.multipleRecord) {
							this.selectedTdu = this.tdus.find((x) => x.duns == response.tdus[0].duns);
						}
					}
					else {
						var dataLayerEvent = 'enroll - step 0: address issue';
						(window as any).dataLayer.push({ 'event': dataLayerEvent, 'error zipcode': address_hash });
						this.is_error_address_yellow = true;
						this.error_address_yellow = this.sharedService.getErrorMessage('address_not_found');
						this.isCheckAvailabilityDisabled = true;
					}
				});
		}
	}

	/** Show the Apartment Unit selector  */
	showApartmentUnitSelector(serviceAddressResponse: any) {
		this.apartmentUnits = serviceAddressResponse.result;
		this.apartmentList = [];
		for (let i = 0; i < this.apartmentUnits.length; i++) {
			if (this.apartmentUnits[i].aptUnit != null && this.apartmentUnits[i].aptUnit !== '') {
				let apartment: string = this.apartmentUnits[i].aptUnit;
				this.apartmentList.push(apartment);
			}
		}

		// No apartments found
		this.is_apt_exist = this.apartmentList.length > 0;
		if (!this.is_apt_exist) {
			this.chooseAparmentUnit('', serviceAddressResponse.result[0]);
			this.isCheckAvailabilityDisabled = false;
			this.sharedService.InvokeHtmlElementEvent('home_next', 'focus');
			return;
		}

		this.showAptItems = true;
		this.apartment_obs = this.apartmentFormControl.valueChanges.startWith(null).map(val => val
			? this.filterApartment(val)
			: this.apartmentList.slice());

		if (serviceAddressResponse.result.length === 1) {
			this.apt_unit = this.apartmentList[0];
			this.chooseAparmentUnit(this.apt_unit, undefined);
		}
		else {
			if (this.apartmentList.length == 1) {
				this.apt_unit = this.apartmentList[0];
				this.chooseAparmentUnit(this.apt_unit, undefined);
			}
			else {
				setTimeout(() => { this.sharedService.InvokeHtmlElementEvent('apartment', 'focus'); }, 100);
			}
		}
	}

	/** Apartment auto-complete filter */
	filterApartment(val: string): string[] {
		setTimeout(() => {
			let isInApt: boolean = this.isInAPtArray(val);
			this.showAptItems = this.apartmentList.length > 0 && !this.is_btn_enable;
			if (isInApt) {
				this.chooseAparmentUnit(this.apt_unit, '');
			}
		}, 100);

		return this.apartmentList.filter(option => option.toLowerCase().includes(val.toLowerCase()) === true);
	}

	scrollToHere(event) {
		let element = event.target;
		if (element !== undefined) {
			element.scrollIntoView();
			document.body.scrollTop = element.offsetTop;
		}
	}

	chooseAparmentUnit(apt_number: string, address_obj: any) {
		if (!apt_number && !address_obj) {
			return;
		}
		this.showAptItems = false;
		if (apt_number !== '') {
			for (let i = 0; i < this.apartmentUnits.length; i++) {
				let apartment = this.apartmentUnits[i].aptUnit;

				if (apartment === apt_number) {
					address_obj = this.apartmentUnits[i];
					this.apt_unit = apartment;
				}
			}
		}

		this.sharedService.InvokeHtmlElementEvent('home_next', 'focus');

		this.duns = address_obj.duns;
		this.esiid = address_obj.esiId;
		this.localStorageService.set('address_for_billing', address_obj);

		// TODO - lifting up setting this 'state' on a 'success'
		// because otherwise will prevent us from navigating.
		//
		this.is_error_address = false;
		this.is_error_address_yellow = false;
		this.isCheckAvailabilityDisabled = false;
		if (address_obj.aptUnit != null && address_obj.aptUnit !== '') {
			this.is_apt_exist = true;
		}
	}

	searchAddress(event: any) {
		this.is_error_address = false;
		this.is_error_address_yellow = false;
		this.is_apt_exist = false;
		this.apt_unit = '';
		this.esiid = '';
		this.apartmentList = [];
		let event_value: string = event.target.value;

		if (!this.isZipCodeSelected) {
			event_value = event.target.value;
		}
		else {
			var temp = event.target.value.split(" ");
			event_value = temp[2];
		}

		let address_hash = this.getHashKeyFromAddress(event_value);
		const context = this;

		if (address_hash != undefined && address_hash.trim() != '') {
			this.selectAddressHash(address_hash);
		}
		else if (event_value.match(ZIPCODE_REGEX)) {
			this.selectAddressHash(event_value);
		}
		else {
			if (event_value != undefined && event_value.trim() != '' && this.service_address_array.length == 0) {
				this.is_error_address_yellow = true;
				this.selectAddressHash(event_value);
			}
		}
	}

	showLoaderIcon(show: boolean) {
		this.showLoader = show;
	}

	tduSelectorChanged() {
		this.isCheckAvailabilityDisabled = !this.selectedTdu;
	}

	navigateTo(url: string) {
		this.router.navigate([url]);
	}
}



// WEBPACK FOOTER //
// ./src/app/check-availability/check-availability.component.ts